/*
  Collection crawl-signal cleaner
  --------------------------------
  Removes sort_by parameters from rel="next" and rel="prev" links
  to prevent duplicate crawl paths.

  Safe:
  • does not alter pagination behaviour
  • does not affect sorting UI
  • no impact on B2B logic
  • runs once after DOM ready
*/

(function () {
  function cleanRelLinks() {
    var links = document.querySelectorAll('link[rel="next"], link[rel="prev"]');
    if (!links.length) return;

    links.forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.searchParams.has('sort_by')) {
          url.searchParams.delete('sort_by');
          link.href = url.pathname + (url.search ? '?' + url.searchParams.toString() : '');
        }
      } catch (e) {
        // fail silently
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanRelLinks, { once: true });
  } else {
    cleanRelLinks();
  }
})();